import { render, staticRenderFns } from "./TournamentDetailDialog.vue?vue&type=template&id=19404443&scoped=true"
import script from "./TournamentDetailDialog.vue?vue&type=script&lang=js"
export * from "./TournamentDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./TournamentDetailDialog.vue?vue&type=style&index=0&id=19404443&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19404443",
  null
  
)

export default component.exports